import { MatDatepickerIntl } from '@angular/material/datepicker';

export function getSpanishDatepickerIntl() {
  const datepickerIntl = new MatDatepickerIntl();

  // En Angular 21+, estas son las propiedades oficiales que controlan los tooltips y botones
  datepickerIntl.switchToMonthViewLabel = 'Elegir mes y año';
  datepickerIntl.switchToMultiYearViewLabel = 'Elegir año';

  // Para los botones de navegación (anterior/siguiente), Angular 21 requiere que usemos las funciones de formato o los nuevos nombres de etiquetas:
  datepickerIntl.calendarLabel = 'Calendario';
  datepickerIntl.openCalendarLabel = 'Abrir calendario';
  datepickerIntl.closeCalendarLabel = 'Cerrar calendario';

  // En las últimas versiones, para cambiar "Previous Month" / "Next Month", debes sobreescribir los métodos que generan los textos de accesibilidad dinámicos:
  datepickerIntl.prevMonthLabel = 'Mes anterior';
  datepickerIntl.nextMonthLabel = 'Siguiente mes';
  datepickerIntl.prevYearLabel = 'Año anterior';
  datepickerIntl.nextYearLabel = 'Siguiente año';

  return datepickerIntl;
}
